module.exports = __webpack_public_path__ + "static/media/IMG_0401.fe15ce9a.JPG";